import { IUser } from '@api/models';
import OverflowTooltip from '@components/OverflowTooltip/OverflowTooltip';
import { SearchIcon } from '@icon/index';
import { Avatar } from '@library/avatar';
import { Checkbox, Input } from '@library/forms';
import { useState } from 'react';

interface UserSelectViewProps {
    users: IUser[];
    selectedUsers: string[];
    onSelectedUsersChange: (users: string[]) => void;
}

const UserSelectView = (props: UserSelectViewProps) => {
    const { users, selectedUsers, onSelectedUsersChange } = props;

    const [searchValue, setSearchValue] = useState('');

    const filteredUsers = users.filter((user) => user.name.toLowerCase().startsWith(searchValue.toLowerCase()));

    return (
        <>
            <div className="relative flex items-center">
                <div className="absolute left-4 ">
                    <SearchIcon className="text-grayscale-400" />
                </div>

                <div className="flex-1">
                    <Input
                        id="users"
                        className="pl-9"
                        placeholder="Search for users..."
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                    />
                </div>
            </div>

            <div className="space-y-4 mt-5 max-h-[350px] overflow-scroll border-2 p-2 rounded-lg">
                {filteredUsers.map((row) => (
                    <label key={row._id} className="flex items-center gap-[10px]">
                        <div>
                            <Avatar src={row.dpUrl} alt={row.name} />
                        </div>

                        <div className="mr-3 overflow-hidden">
                            <OverflowTooltip className="font-medium text-sm">{row.name}</OverflowTooltip>
                            <OverflowTooltip className="font-medium text-xs text-grayscale-400">
                                {row.email}
                            </OverflowTooltip>
                        </div>

                        <div className="ml-auto">
                            <Checkbox
                                id={row._id}
                                checked={selectedUsers.includes(row._id)}
                                onCheckedChange={(checked) =>
                                    checked
                                        ? onSelectedUsersChange([...selectedUsers, row._id])
                                        : onSelectedUsersChange(selectedUsers.filter((_id) => _id !== row._id))
                                }
                                size="lg"
                            />
                        </div>
                    </label>
                ))}

                {filteredUsers.length === 0 && (
                    <div className="font-medium text-sm text-grayscale-500">No users found</div>
                )}
            </div>
        </>
    );
};

export default UserSelectView;
